import type { ButtonLinkSizeMapping } from "./button-link.type";

export const BUTTON_LINK_SIZE_MAPPING: ButtonLinkSizeMapping = {
  small: "sm",
  medium: null,
  large: "lg",
};
